import ToastEvents from '@ordermentum/ui-toast/constants';
import C from './constants';
import notificationEvents from './notification_events';
import asyncActions from './async';
import syncActions from './sync';

const constants = {
  ...C,
  ...notificationEvents,
  ...asyncActions,
  ...syncActions,
  ...ToastEvents,
};

export default constants;
